module.exports = __webpack_public_path__ + "img/OCB.2efc4eed.svg";